<style lang="scss" scoped>
.keepwidth {
    min-width: 50px;
    display: inline-block;
}
.percentstat {
    width: 45px;
    white-space: nowrap;
    text-align: center;
    display: inline-block;
    background: #fff;
    padding: 0.2em;
    border-radius: 4px;
    padding: 0.2em;
    font-size: 0.8em;
}

tr.summary {
    background: #ddd !important;
    font-weight: bold !important;
    td {
        padding-top: 10px;
        padding-bottom: 10px;
    }
}

tr.reference {
    background: rgb(192, 204, 245) !important;
}
tr.chosen {
    background: rgb(192, 245, 215) !important;
}
tr.notRelevant {
    opacity: 0.15;
}

.significance {
    border-radius: 4px;
    margin: 2px;
    display: inline-block;
    color: #aaa;
    font-weight: bold;

    padding: 2px 0;
    .pct {
        width: 40px;
        display: inline-block;
        font-weight: bold;
    }

    &.significant {
        padding: 2px 5px;
        color: #fff;
        background: rgb(58, 192, 58);

        &:not(.goodImpact) {
            background: rgb(255, 0, 47);
        }
    }
}

.progress {
    width: 100%;
    height: 15px;
    border-radius: 4px;
    overflow: hidden;
    background: rgba(#000, 0.05);
    position: relative;
    display: flex;
    margin-bottom: 10px;

    > .bar {
        height: 100%;
        display: inline-flex;
        position: relative;
        z-index: 10;
        background: #aaacb4;
    }

    > .label {
        position: absolute;
        font-size: 13px;
        top: 50%;
        color: #000;
        z-index: 20;
        border-radius: 4px;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.referenceBadge,
.winnerBadge {
    color: #fff;
    text-transform: uppercase;
    background: rgb(72, 110, 234);
    border-radius: 4px;
    display: inline-flex;
    font-weight: bold;
    padding: 0.1em 0.4em 0.2em;
    font-size: 0.8em;
    margin-left: 10px;
}

.winnerBadge {
    background: rgb(65, 198, 98);
}

.mappedName {
    display: flex;
    align-items: center;
}

.delta {
    color: rgb(255, 0, 47);

    display: inline-block;
    font-weight: bold;
    margin-left: 10px;
    &.positive {
        color: rgb(27, 178, 27);
    }
}

.confident {
    filter: blur(10px);
}
</style>

<template lang="pug">
div
  h1 AB Tests
    button.icon(@click="refreshData", :disabled="refreshing")
      fa(icon="sync-alt")

  label A/B Test:
    select(v-model="testFilter", placeholder="Test name", :disabled="refreshing")
        option(v-for="(test, index) in availableTests", :value="test") {{index}}: {{test}}
  br
  label
    input(type="checkbox" v-model="revenueIndependent", :disabled="refreshing")
    | Same sale price for every country
  br
  label
    input(type="checkbox" v-model="excludeOtherAb", :disabled="refreshing")
    | Exclude participants of other A/B tests
  br
  label
    input(type="checkbox" v-model="excludeFullWeb", :disabled="refreshing")
    | Exclude full web version plays
  br
  label
    input(type="checkbox" v-model="excludeOtherPlatform", :disabled="refreshing")
    | Exclude other platforms
  br
  label
    input(type="checkbox" v-model="includeCracked", :disabled="refreshing")
    | Include cracked in score

  br
  | Acquisition channel:
  label
    input(v-model="filter", placeholder="Filter by acquisition channel ...", style="width: 400px", :disabled="refreshing")
  button(@click="filter = ''", :disabled="refreshing") All
  | &nbsp;
  button(@click="filter = 'prod_'", :disabled="refreshing") web (shapez.io)
  | &nbsp;
  button(@click="filter = 'steam-demo_'", :disabled="refreshing") Steam Demo
  | &nbsp;
  button(@click="filter = 'ga_'", :disabled="refreshing") Google Ads
  | &nbsp;
  button(@click="filter = 'broad'", :disabled="refreshing") FB Ads

  br
  .platform(v-for="platform in ['prod', 'steam-demo']")
    h2 Platform: {{platform}}


    template(v-if="refreshing") Loading {{loadingCount}} entries
    template(v-else v-for="result in [testResults(platform)]")
        .progress
            .bar(:style="{ width: (getAcquiredUsers(platform) / getRequiredUsers(platform) * 100.0).toFixed(2) + '%' }")
            .label {{getAcquiredUsers(platform)}} / {{getRequiredUsers(platform)}}
        table(v-if="links")

            thead
                th(width="500px") Test name
                th Users
                th Demo started
                th Demo completed
                th Cracked
                th Revenue
                th Standalone Sales
                th DLC Sales
                th
                    strong Revenue / User
                th
                    strong Confidence

            tr(v-for="entry in result.results", :class="{ summary: entry.$total, reference: entry.reference, chosen: entry.winner, notRelevant: entry.users < getRequiredUsersSingle(platform) }")
                td
                    .mappedName {{entry.mappedName}}
                        .referenceBadge(v-if="entry.reference") reference
                        .winnerBadge(v-if="entry.winner") Winner
                td(:class="{confident}") {{entry.users}}
                td
                    .keepwidth(:class="{confident}") {{platform === 'prod' ? entry.webStarted : entry.demoStarted}}
                    .percentstat {{ ((platform === 'prod' ? entry.webStarted : entry.demoStarted) / entry.users * 100.0).toFixed(1) }} %
                td
                    .keepwidth(:class="{confident}") {{platform === 'prod' ? entry.webFinished : entry.demoFinished}}
                    .percentstat {{ ((platform === 'prod' ? entry.webFinished : entry.demoFinished) / entry.users * 100.0).toFixed(1) }} %
                td
                    .keepwidth(:class="{confident}") {{entry.cracked}}
                    .percentstat {{ ((entry.cracked) / entry.users * 100.0).toFixed(1) }} %
                td(:class="{confident}") {{ formatCurrency(entry.revenue)}} €
                td
                    .keepwidth(:class="{confident}") {{entry.standalonePurchases}}
                    .percentstat {{ ((entry.standalonePurchases) / entry.users * 100.0).toFixed(1) }} %
                td
                    .keepwidth(:class="{confident}") {{entry.puzzleDlc}}
                    .percentstat {{ ((entry.puzzleDlc) / entry.users * 100.0).toFixed(1) }} %
                td
                    strong(:class="{confident}") {{ formatCurrency(entry.revenue / entry.users) }} €
                    .delta(v-if="!entry.reference && !entry.$total && entry.users >= getRequiredUsersSingle(platform)", :class="{positive: entry.deltaRevenue > 0}")
                        | &nbsp; {{entry.deltaRevenue > 0 ? "+" : "-"}} {{Math.round(Math.abs(entry.deltaRevenue) * 100.0)}}%
                td
                    .significance(v-if="!entry.$total && entry.chiLikeliness", :class="{ significant: entry.chiLikeliness > 0.9 && entry.users > getRequiredUsersSingle(platform), goodImpact: entry.deltaRevenue > 0 }") {{(entry.chiLikeliness * 100.0).toFixed(1)}} %

</template>

<script>
import ApiService from "../services/api";
const chiSquared = require("chi-squared");

const todaySeconds = new Date();
todaySeconds.setHours(0, 0, 0, 0);

const NAME_MAPPINGS = {
    sa_si_0: "Show steam ad every 5 mins",
    sa_si_1: "Show steam ad every 10 mins",
    sa_si_2: "Show steam ad every 15 mins",
    sa_si_3: "Show steam ad every 20 mins",
    sa_si_4: "Show steam ad not at all",

    ilig_0: "Skip main menu, show ad first time",
    ilig_1: "Skip main menu, show ad after 15-20 mins",
    ilig_2: "Show main menu, show ad after first time",
    ilig_3: "Show main menu, show ad after 15-20 mins",

    dlbtn_0: "Btn: Play on Steam",
    dlbtn_1: "Btn: Buy on Steam",
    dlbtn_2: "Btn: Get on Steam",
    dlbtn_3: "Btn: View on Steam",
    dlbtn_4: "Btn: Purchase on Steam",
    dlbtn_5: "Btn: Download on Steam",

    wmlt_0: "Get on Steam",
    wmlt_1: "Play on Steam",
    wmlt_2: "Get on Steam (localized)",

    dif_0: "20% difficulty",
    dif_1: "50% difficulty",
    dif_2: "75% difficulty",
    dif_3: "100% difficulty",
    dif_4: "125% difficulty",
    dif_5: "200% difficulty",

    spl_0: "Steam Store Page",
    spl_1: "Steam Full Version Bundle Page",
    spl_2: "Steam protocol (steam://)",

    sacb_0: "Show button instant",
    sacb_1: "Show button after 1s (50% fade)",
    sacb_2: "Show button after 2.5s (50% fade)",
    sacb_3: "Show button after 5s (50% fade)",
    sacb_4: "Show button after 10s (20/80% fade)",

    mmat_0: "Show '24 hours content'",
    mmat_1: "Show nothing",
    mmat_2: "Show X players playing",

    dmtm_0: "Show steam ad every 15-20 min",
    dmtm_1: "Limit demo to 15 minutes and then show ad",
    dmtm_2: "Limit demo to 30 minutes and then show ad",

    unl_0: "Allow only until level 8",
    unl_1: "Allow until level 12",

    bsln_0: "Baseline",
    bsnv_0: "Baseline V2",
    mmnd_0: "Baseline V3",

    lvcp_0: "Baseline",
    lvcp_1: "Lower level requirements L8",
    lvcp_2: "Only to level L7",
    lvcp_3: "Only to level L6",

    dsct_0: "Do not show discount",
    dsct_1: "Include 10% discount",

    ssst_0: "Bundle 60%",
    ssst_1: "Bundle 60% Special Offer",
    ssst_2: "Basegame 60%",
    ssst_3: "Basegame 60% Special Offer",

    bsl2_0: "Baseline",
};

const REFERENCES = {
    sa_si: 1,
    ilig: 2,
    dlbtn: 0,
    wmlt: 2,
    dif: 3,
    spl: 0,
    sacb: 3,
    mmat: 0,
    dmtm: 0,
    unl: 0,
    bsln: 0,
    bsnv: 0,
    mmnd: 0,
    lvcp: 0,
    dsct: 0,
    ssst: 0,
    bsl2: 0,
};

const CHOSEN = {
    "prod": {
        sa_si: 2,
        ilig: 3,
        dlbtn: 0,
        wmlt: 2,
        dif: 1,
        spl: 1,
        sacb: 4,
        mmat: 2,
        dmtm: 2,
    },
    "steam-demo": {
        sa_si: 3,
        ilig: 2,
        dlbtn: 0,
        wmlt: 2,
        dif: 2,
        spl: 1,
        sacb: 3,
        mmat: 0,
        dmtm: 11,
    },
};

const TEST_ORDER = Array.from(Object.keys(REFERENCES));

export default {
    data: () => ({
        referenceCampaign: 0,
        testFilter: "",
        revenueIndependent: false,
        filter: "",
        links: null,
        refreshing: false,
        excludeOtherAb: true,
        loadingCount: 0,
        confident: window.location.search.includes("confident"),
        minimumConversions: 8,
        excludeOtherPlatform: true,
        includeCracked: false,
        excludeFullWeb: true,
    }),
    async mounted() {
        this.testFilter = TEST_ORDER[TEST_ORDER.length - 1];
        await this.refreshData();
    },
    beforeDestroy() {},
    watch: {
        testFilter(value) {
            if (value in REFERENCES) {
                this.referenceCampaign = REFERENCES[value];
            }
            this.refreshData();
        },
        filter() {
            this.refreshData();
        },
        excludeOtherAb() {
            this.refreshData();
        },
        excludeOtherPlatform() {
            this.refreshData();
        },
        excludeFullWeb() {
            this.refreshData();
        },
    },

    computed: {
        availableTests() {
            return TEST_ORDER;
        },
    },

    methods: {
        getVariants() {
            return Array.from(Object.keys(NAME_MAPPINGS)).filter(key => key.startsWith(this.testFilter));
        },

        getRequiredUsers(platform) {
            return Math.ceil(this.getRequiredUsersSingle(platform) * this.getVariants().length);
        },

        getRequiredUsersSingle(platform) {
            const conversionRate = platform === "prod" ? 0.0125 : 0.05;
            return Math.ceil(this.minimumConversions / conversionRate);
        },

        getAcquiredUsers(platform) {
            if (!this.links) {
                return;
            }
            return this.links
                .filter(
                    l => l.initialCampaign.includes(this.testFilter) && l.initialCampaign.includes(platform)
                )
                .reduce((a, b) => a + b.users, 0);
        },

        testResults(platform) {
            if (!this.links) {
                return [];
            }

            const baseKey = platform + "_abt_" + this.testFilter + "_";
            const results = [];

            const chosenIndex = CHOSEN[platform][this.testFilter];

            for (let index = 0; index < 10; ++index) {
                let entry = this.links.find(link => link.initialCampaign === baseKey + String(index));
                if (!entry) {
                    continue;
                }
                const clone = { ...entry };

                if (this.includeCracked) {
                    clone.standalonePurchases += clone.cracked;
                }

                if (this.revenueIndependent) {
                    clone.totalPurchases = clone.standalonePurchases + clone.puzzleDlc * 0.5;
                    clone.revenue = clone.standalonePurchases * 9.99 * 0.55 + clone.puzzleDlc * 4.99 * 0.55;
                } else {
                    clone.totalPurchases = clone.revenue / 5.45;
                }

                clone.purchases = clone.standalonePurchases;

                clone.mappedName =
                    index + ": " + NAME_MAPPINGS[this.testFilter + "_" + index] || clone.initialCampaign;
                clone.deltaRevenue = 0;
                clone.significances = [];
                if (clone.initialCampaign === baseKey + this.referenceCampaign) {
                    clone.reference = true;
                }
                if (index === chosenIndex) {
                    clone.winner = true;
                }
                results.push(clone);
            }

            for (const result of results) {
                let other = results.find(r => r.initialCampaign === baseKey + this.referenceCampaign);
                if (other === result) {
                    continue;
                }

                if (!other) {
                    console.warn(
                        "Failed to find reference:",
                        baseKey + this.referenceCampaign,
                        "for",
                        result.initialCampaign
                    );
                    other = {
                        users: 0,
                        totalPurchases: 0,
                    };
                }

                const totalUsers = result.users + other.users;
                const totalPurchased = result.totalPurchases + other.totalPurchases;

                const expectedConversionRate = totalPurchased / totalUsers;
                const expectedNonConversionRate = (totalUsers - totalPurchased) / totalUsers;

                let values = [
                    // result: converted
                    { expected: result.users * expectedConversionRate, actual: result.totalPurchases },
                    // result: not converted
                    {
                        expected: result.users * expectedNonConversionRate,
                        actual: result.users - result.totalPurchases,
                    },
                    // others: converted
                    { expected: other.users * expectedConversionRate, actual: other.totalPurchases },
                    // others: not converted
                    {
                        expected: other.users * expectedNonConversionRate,
                        actual: other.users - other.totalPurchases,
                    },
                ];

                let chi = 0;
                for (const value of values) {
                    chi += Math.pow(Math.abs(value.actual - value.expected), 2) / value.expected;
                }

                result.chi = chi;

                const currentRevPerUser = result.revenue / result.users;
                const referenceRevPerUser = other.revenue / other.users;

                result.deltaRevenue = currentRevPerUser / referenceRevPerUser - 1;
                result.chiLikeliness = chiSquared.cdf(chi, 1);
            }

            const props = [
                "users",
                "totalClicks",
                "standalonePurchases",
                "standaloneTotal",
                "web",
                "demo",
                "puzzleDlc",
                "webStarted",
                "demoStarted",
                "demoFinished",
                "webFinished",
                "revenue",
                "totalPurchases",
                "cracked",
            ];
            let aggregated = {};
            for (const prop of props) {
                aggregated[prop] = results.reduce((v, link) => v + link[prop], 0);
            }

            results.push({
                $total: true,
                initialCampaign: "TOTAL",
                ...aggregated,
                chi: 0,
                significances: [],
                deltaRevenue: 0,
            });
            return { results };
        },

        async refreshData() {
            if (this.refreshing) {
                return;
            }
            this.refreshing = true;

            let variants = Array.from(Object.keys(NAME_MAPPINGS)).filter(key =>
                key.startsWith(this.testFilter)
            );
            let excludedVariants = Array.from(Object.keys(NAME_MAPPINGS)).filter(
                key => !variants.includes(key)
            );
            let excludedQuery = excludedVariants
                .map(variant => `"link_tracking"."clickHistory" not ilike '%abt_${variant}%'`)
                .join(" AND ");
            let promises = [];
            let results = [];
            this.links = [];
            this.loadingCount = variants.length * 2;

            if (!this.excludeOtherAb) {
                excludedQuery = " true ";
            }

            let additionalFilter = "";
            if (this.excludeFullWeb) {
                additionalFilter = ` and ("steamCommit" is null or "steamCommit" not ilike 'unknown') `;
            }

            for (const platform of ["prod", "steam-demo"]) {
                let localExcluded = excludedQuery;

                if (this.excludeOtherPlatform) {
                    const otherPlatform = platform === "prod" ? "steam-demo" : "prod";
                    localExcluded += ` and "clickHistory" not ilike '%${otherPlatform}%${platform}%' `;
                }
                for (const variant of variants) {
                    const fullName = platform + "_abt_" + variant;
                    promises.push(
                        (async () => {
                            console.log("Fetching extra data for", variant);
                            const fullData = (
                                await ApiService.query(
                                    `

                    select
                        count(*)::int as users,
                        sum(LEAST("linkClicks", 5))::int as "totalClicks",

                        sum(coalesce("steamOwnsApp"::int,0))::int as "standalonePurchases",

                        sum("webPlays")::int as web,
                        sum("demoPlays")::int as demo,
                        sum("puzzleDlcPlays" * coalesce("steamOwnsApp"::int,0))::int as "puzzleDlc",

                        sum("launchedWithoutSteam" * (1 - coalesce("steamOwnsApp"::int,0)))::int as "cracked",

                        sum(LEAST("webMaxLevel", 1))::int as "webStarted",
                        sum(LEAST("demoMaxLevel", 1))::int as "demoStarted",

                        sum(coalesce("purchasePriceGame", 0) * coalesce("steamOwnsApp"::int,0) + coalesce("purchasePriceDlc", 0) * coalesce("steamOwnsApp"::int,0) * "puzzleDlcPlays")::float as "revenue",

                        sum(LEAST(GREATEST("demoMaxLevel" - 7, 0), 1))::int as "demoFinished",
                        sum(LEAST(GREATEST("webMaxLevel" - 7, 0), 1))::int as "webFinished"

                    from link_tracking

                    where
                        "link_tracking"."clickHistory" ilike '%${fullName}%'
                        and (${localExcluded})
                        and "initialCampaign" ilike ~filter
                        ${additionalFilter}


                `,
                                    { filter: "%" + this.filter + "%", campaign: fullName }
                                )
                            )[0];
                            results.push({ ...fullData, initialCampaign: fullName });
                            this.loadingCount -= 1;
                        })()
                    );
                    if (promises.length > 5) {
                        await Promise.all(promises);
                        promises = [];
                    }
                }
            }

            try {
                await Promise.all(promises);
            } catch (ex) {
                alert("Failure: " + ex);
            } finally {
                this.refreshing = false;
            }
            this.links = results;
        },

        conversionCount(link) {
            return link.standalonePurchases + link.puzzleDlc;
        },

        formatCurrency(value) {
            // if (value > 999.99) {
            //     return Math.round(value).toLocaleString("de-DE");
            // }
            return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" })
                .format(value)
                .replace("€", "")
                .replace(/\s/gi, "");
        },

        formatNumber(value) {
            if (!value) {
                return 0;
            }
            if (value > 9999) {
                return (value / 10000).toFixed(1) + "k";
            }
            return String(value);
        },
    },
};
</script>
